import React, { useEffect, useState } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const ProductTypeSelect = ({ title, defaultValue = null, handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectProductType") : title;
  const [productTypes, setProductTypes] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState(null);

  const handleChange = (e) => {
    setSelectedProductType(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getProductTypes = async () => {
    try {
      const response = await apiService.get(`api/v1/product-types`);
      const availableProductTypes = response.map((el) => {
        return {
          value: el.id,
          label: el.description,
        };
      });
      setProductTypes(availableProductTypes);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedProductType = productTypes.find((el) => el.value === defaultValue);
    if (selectedProductType) setSelectedProductType(selectedProductType);
  };

  useEffect(() => {
    getProductTypes();
  }, []);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="productTypeSelect"
          onChange={handleChange}
          value={selectedProductType}
          options={productTypes}
          noOptionsMessage={() => t("messages.noProductTypesAreAvailable")}
          placeholder={`${t("common.actions.select")} ${title}`}
        />
      </Form.Group>
    </>
  );
};

export default ProductTypeSelect;
